import workspaceQuery from '../../../graphql/queries/product/AssemblyRequirementDetailWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/AssemblyRequirementDetailQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/AssemblyRequirementDetailDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/AssemblyRequirementDetailMutation.graphql';
import fragment from '../../../graphql/fragments/product/AssemblyRequirementDetailFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { assemblyRequirementWorkspaceActionsForPermissions } from '../../../actions/product/AssemblyRequirementWorkspaceAction';

const AssemblyRequirementDetail: EntityType = {
  type: 'AssemblyRequirementDetail',
  title: 'Assembly Shortages',
  formUrl: '/Products/Assembly/AssemblyShortages/Details/',
  formTitle: 'Assembly Shortage',
  workspaceUrl: '/Products/Assembly/AssemblyShortages/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'ASSEMBLY_REQUIREMENT_DETAIL',
  actions: [...assemblyRequirementWorkspaceActionsForPermissions],
};

export default AssemblyRequirementDetail;
